export default "__VITE_ASSET__VmqKBbth__"